import { A } from '@solidjs/router'
import { userStore } from '/web/store'

export default function CTAStrip() {
  const state = userStore()
  const loggedIn = () => state.loggedIn

  return (
    <section class="relative flex min-h-[420px] items-center overflow-hidden bg-[var(--cf-bg)] sm:min-h-[520px]">
      {/* Background mosaic image */}
      <div
        class="absolute inset-0 z-0"
        style={{
          'background-image': 'url(/images/cta-mosaic-bg-v5.jpg)',
          'background-size': 'cover',
          'background-position': 'center',
          opacity: '0.8',
        }}
      />

      {/* Gradient overlay — opaque left, transparent right */}
      <div
        class="absolute inset-0 z-[1]"
        style={{
          background:
            'linear-gradient(to right, rgba(11,11,15,1) 0%, rgba(11,11,15,0.95) 30%, rgba(11,11,15,0.6) 70%, rgba(11,11,15,0.2) 100%)',
        }}
      />

      {/* Content */}
      <div class="relative z-[2] max-w-[560px] px-[var(--cf-gutter)] py-14 lg:px-20 lg:py-20">
        <h2 class="mb-4 font-bebas leading-[1.05] tracking-[1px]" style={{ 'font-size': 'clamp(36px, 5vw, 64px)' }}>
          JOIN THE #1
          <br />
          AI COMPANION
          <br />
          EXPERIENCE
        </h2>
        <p class="mb-6 max-w-[420px] text-[16px] leading-[1.65] text-[rgba(240,234,248,0.7)]">
          {loggedIn()
            ? 'Pick up where you left off — explore creators, generate, and chat.'
            : 'Meet stunning AI characters and explore unlimited fantasies, only on CosplayFans.'}
        </p>
        {loggedIn() ? (
          <A
            href="/characters"
            class="cf-btn inline-flex"
            style={{
              background: 'var(--cf-grad-hot)',
              'box-shadow': '0 4px 25px rgba(255,60,172,0.35)',
            }}
          >
            Browse Characters →
          </A>
        ) : (
          <button
            class="cf-btn"
            style={{
              background: 'var(--cf-grad-hot)',
              'box-shadow': '0 4px 25px rgba(255,60,172,0.35)',
            }}
            onClick={() => userStore.loginModal(true)}
          >
            Sign Up For FREE
          </button>
        )}
      </div>
    </section>
  )
}
